export default __webpack_public_path__ + "static/media/S (29).fcbb847f.png";